import * as React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import errorReporter from '@app/errorReporter';
import { message } from 'components';

import Loading from '../MyBusinessPage/components/Loading';
import { useGetGroup } from './hooks';

import NewGroupsHeader from './NewGroupsHeader';
import NewGroupsMainPage from './NewGroupsMainPage';

const NewGroupsPage: React.FC = () => {
  const history = useHistory();
  const { groupId } = useParams<{ groupId: string }>();

  const { groupName, groupMembers, setGroupName, setGroupMembers, isLoading } =
    useGetGroup(groupId);

  const [isSaving, setIsSaving] = React.useState(false);

  const back = () => {
    history.goBack();
  };
  const save = async () => {
    if (!groupName.trim() || !groupMembers?.length) {
      message.error('A group name and at least 1 agent is required.');
    } else {
      try {
        setIsSaving(true);
        await axios.post('/group', {
          id: groupId,
          name: groupName,
          users: groupMembers,
        });
      } catch (err) {
        errorReporter.error(err);
      } finally {
        back();
      }
    }
  };

  return (
    <>
      <NewGroupsHeader
        save={save}
        back={back}
        isLoading={isLoading || isSaving}
      />
      {isLoading || isSaving ? (
        <Loading />
      ) : (
        <NewGroupsMainPage
          groupName={groupName}
          groupMembers={groupMembers}
          setGroupName={setGroupName}
          setGroupMembers={setGroupMembers}
        />
      )}
    </>
  );
};

export default NewGroupsPage;
